import { render, staticRenderFns } from "./FormDokter.vue?vue&type=template&id=0c43e16b&"
import script from "./FormDokter.vue?vue&type=script&lang=js&"
export * from "./FormDokter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports